var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cmp-md-attrs-inline-viewer',{attrs:{"attributes":_vm.mValue,"show-field-name":_vm.params.showFieldName,"distinct":_vm.params.distinct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }